(function() {
    angular
        .module("loginModule")
        .controller("LoginController", LoginController)

    LoginController.$inject = [
        "$scope",
        "$rootScope",
        "$state",
        "authenticationService"
    ]

    function LoginController(
        $scope,
        $rootScope,
        $state,
        authenticationService
    ){
        "use strict"

        authenticationService.logoutSoft()

        /**
            $rootScope variables
         **/
        $rootScope.title = "Login | WANCO"

        /**
            $scope variables
         **/
        $scope.formData          = {}
        $scope.inputType         = "password"
        $scope.formData.remember = false

        /**
            Show/hide password
         **/
        $scope.hideShowPassword = function() {
            if ($scope.inputType == "password") {
                $scope.inputType = "text"
            } else {
                $scope.inputType = "password"
            }
        }

        /**
            Remember me
         **/
        if (!$.isEmptyObject($rootScope.remember_user)) {
            $scope.formData.remember = true
            $scope.formData.username = $rootScope.remember_user
        }

        /**
            Login form
         **/
        $scope.login = function() {

            $scope.submitted = true
            $scope.formSuccess = false

            if ($scope.loginForm.$valid) {

                authenticationService.login(
                    $scope.formData.username,
                    $scope.formData.password,
                    function() {
                        //Success
                        if ($scope.formData.remember) {
                            authenticationService.setRememberCookie($scope.formData.username)
                        } else {
                            authenticationService.removeRememberCookie()
                        }
                        $state.go("devices", null, { reload: true })
                    },
                    function() {
                        //Failure
                    }
                )
            }
        }
    }
})()
